<template>
	<div class="login-wrap">
		<div class="ms-login">
			<div class="ms-title">后台管理系统</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ms-content" size="large">
				<el-form-item prop="username">
					<el-input v-model="ruleForm.username" placeholder="username" size="large">
						<i slot="prepend" class="icon-lx-people"></i>
					</el-input>
				</el-form-item>
				<el-form-item prop="password">
					<el-input type="password" placeholder="password" v-model="ruleForm.password"
						@keyup.enter.native="submitForm('ruleForm')" size="large">
						<i slot="prepend" class="icon-lx-lock"></i>
					</el-input>
				</el-form-item>
				<div class="login-btn">
					<el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
				</div>
				<p class="login-tips"></p>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		data: function() {
			return {
				ruleForm: {
					username: '',
					password: ''
				},
				rules: {
					username: [{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: '请输入密码',
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					let loading = this.$loading({
						fullscreen: true,
						lock: true,
						background: 'rgba(0,0,0,0.5)'
					});
					window.ax.post('api/user/login', {
						UserName: this.ruleForm.username,
						Password: this.ruleForm.password,
						Sign: localStorage.getItem('ms_usign')
					}).then(response => {
						let d = response.data;
						let usign = d[0];
						if (usign) {
							let uname = d[2];
							let nickname = d[3];
							let rolename = d[4];
							let lastip = d[5];
							let lasttime = d[6];
							let nowip = d[7];
							let nowtime = d[8];
							let sex = d[9];
							let headimage = d[10];
							window.$gloable.userinfo.sign = usign;
							let ui = {
								name: uname,
								nickname: nickname,
								rolename: rolename,
								lastip: lastip,
								lasttime: lasttime,
								nowip: nowip,
								nowtime: nowtime,
								sex: sex,
								headimage: 'api/resource/image/HeadImage?name=' + headimage + '.jpg'
							};
							window.$gloable.userinfo.obj = ui;
							localStorage.setItem('ms_usign', usign);
							localStorage.setItem('ms_uinfo', JSON.stringify(ui));
							this.$router.push('/');
						} else {
							this.$message.error('登录验证失败');
						}
						loading.close();
					}).catch(error => {
						this.$messager.error('执行脚本出错，请联系管理员');
						loading.close();
					});
				});
			}
		}
	}
</script>

<style scoped>
	.login-wrap {
		position: relative;
		width: 100%;
		height: 100%;
		background-image: url(../../assets/img/login-bg.jpg);
		background-size: 100%;
	}

	.ms-title {
		width: 100%;
		line-height: 50px;
		text-align: center;
		font-size: 20px;
		color: blue;
		font-weight: bold;
		border-bottom: 1px solid #ddd;
	}

	.ms-login {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 350px;
		margin: -190px 0 0 -175px;
		border-radius: 5px;
		background: rgba(255, 255, 255, 0.3);
		overflow: hidden;
	}

	.ms-content {
		padding: 30px 30px;
	}

	.login-btn {
		text-align: center;
	}

	.login-btn button {
		width: 100%;
		height: 36px;
		margin-bottom: 10px;
	}

	.login-tips {
		font-size: 12px;
		line-height: 30px;
		color: #fff;
	}

	/deep/ .el-form-item__error {
		font-size: 16px !important;
		margin-left: 80px;
	}
</style>
